import { render, staticRenderFns } from "./virtualDevice.vue?vue&type=template&id=1b2031a8&scoped=true&"
import script from "./virtualDevice.vue?vue&type=script&lang=js&"
export * from "./virtualDevice.vue?vue&type=script&lang=js&"
import style0 from "./virtualDevice.vue?vue&type=style&index=0&id=1b2031a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2031a8",
  null
  
)

export default component.exports